import { ParentModel } from './parent.model';

export class PreviewCrossesModel {
    constructor(
        public gid: number,
        public entryNumber: number,
        public femaleParents: ParentModel[],
        public maleParents: ParentModel[],
        public femalePedigreeString: string,
        public malePedigreeString: string,
        public seedSource: string,
        public breedingMethodId: number,
        public breedingMethodName: string,
        public hasExistingCrosses: boolean,
        public cross: string,
        public rawBreedingMethod: string,
        public crossType: string,
        public duplicateOrderedMap: Map<string, string>
    ) {
    }
}

export enum CrossType {
    MULTIPLY = 'MULTIPLY',
    TOP_TO_BOTTOM = 'TOP_TO_BOTTOM',
    UNKNOWN_MALE = 'UNKNOWN_MALE',
    MULTIPLE_MALE = 'MULTIPLE_MALE',
    MULTIPLE_PARENT = 'MULTIPLE_PARENT'
}
